import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import CircularTickIcon from '../svg/CircularTickIcon';

export default function ImageCheckbox({ title, appUse, setAppUse, icon, checkboxName }) {
  return (
    <Box
      style={{
        height: '100px',
        background: '#fff',
        border: `1px solid ${appUse === checkboxName ? '#2675ff' : 'rgba(0,0,0,0.08)'}`,
        borderRadius: '12px',
        cursor: 'pointer',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onClick={() => setAppUse(checkboxName)}
    >
      <img src={icon} alt={`${checkboxName} icon`} />
      {appUse === checkboxName && (
        <Box sx={{ position: 'absolute', top: '10px', right: '10px' }}>
          <CircularTickIcon />
        </Box>
      )}
      <h3 style={{ marginLeft: 10 }}>{title}</h3>
    </Box>
  );
}

ImageCheckbox.propTypes = {
  title: PropTypes.string,
  appUse: PropTypes.string,
  setAppUse: PropTypes.func,
  icon: PropTypes.string,
  checkboxName: PropTypes.string
};
